import { useEffect, useRef, useState } from "react";
import { api } from "@/lib/api";
import { Input } from "@/components/ui/input";
import { Loader2, Search } from "lucide-react";

export function SearchableSelect({ onSelect, excludeIds = [], placeholder = "Buscar por número, descrição, quadra ou lote…" }) {
  const [q, setQ] = useState("");
  const [items, setItems] = useState(null);
  const [loading, setLoading] = useState(true);
  const timer = useRef(null);

  useEffect(() => {
    clearTimeout(timer.current);
    setLoading(true);
    timer.current = setTimeout(() => {
      api.get("/tenant/brave/eqls", { params: { q, limit: 25 } })
        .then(({ data }) => setItems(data))
        .catch(() => setItems([]))
        .finally(() => setLoading(false));
    }, 300);
    return () => clearTimeout(timer.current);
  }, [q]);

  const visible = (items || []).filter((i) => !excludeIds.includes(i.id));

  return (
    <div data-testid="eql-searchable-select">
      <div className="relative">
        <Search className="h-4 w-4 text-zinc-500 absolute left-3 top-1/2 -translate-y-1/2 pointer-events-none" />
        <Input data-testid="eql-search-input" value={q} onChange={(e) => setQ(e.target.value)} autoFocus
          placeholder={placeholder}
          className="pl-9 bg-zinc-950 border-zinc-800 text-zinc-100 placeholder:text-zinc-600 rounded-md focus:border-indigo-500" />
      </div>
      <div className="mt-2 max-h-56 overflow-y-auto rounded-md border border-zinc-800 divide-y divide-zinc-800/60" data-testid="eql-search-results">
        {loading ? (
          <div className="flex items-center justify-center py-6"><Loader2 className="h-4 w-4 animate-spin text-indigo-400" /></div>
        ) : visible.length === 0 ? (
          <p className="text-xs text-zinc-500 text-center py-6" data-testid="eql-search-empty">Nenhuma EQL encontrada.</p>
        ) : visible.map((e) => (
          <button key={e.id} type="button" data-testid={`eql-option-${e.id}`} onClick={() => onSelect(e)}
            className="w-full text-left px-3 py-2 hover:bg-zinc-800/60 transition-colors duration-150">
            <span className="text-sm text-zinc-100">{[e.numero, e.descricao].filter(Boolean).join(" — ") || e.id}</span>
            <span className="block text-[11px] text-zinc-500">
              {[e.gleba && `Gleba ${e.gleba}`, e.quadra && `Quadra ${e.quadra}`, e.lote && `Lote ${e.lote}`].filter(Boolean).join(" · ") || " "}
            </span>
          </button>
        ))}
      </div>
    </div>
  );
}
